import React from 'react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { QueryClient, QueryClientProvider, QueryObserverOptions } from '@tanstack/react-query';

const BASE_OPTIONS: QueryObserverOptions = {
  networkMode: 'always',
  refetchOnReconnect: false,
  refetchOnWindowFocus: false,
  refetchOnMount: false,
  retry: 0,
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { ...BASE_OPTIONS },
  },
});

interface GradesTableQueryClientProviderProps {
  children?: React.ReactNode;
}

const AssignmentBasedQueryClientProvider = ({ children = null }: GradesTableQueryClientProviderProps) => (
  <QueryClientProvider client={queryClient}>
    <ReactQueryDevtools initialIsOpen={false} />
    {children}
  </QueryClientProvider>
);

export default AssignmentBasedQueryClientProvider;
